(function() {

  const zfrespond = {
    app: {},
    views: {},
    models: {}
  };
  
  $.ajaxSetup({ 
    cache: false,
    beforeSend: function(xhr, settings){
      xhr.setRequestHeader('X-CSRF-Token', window.CSRF_TOKEN);
    } 
  });

  module.exports = zfrespond;

}());